import ProductMapper from '../exhibitingOrganisation/ProductMapper';
import ExhibitorMapper from '../exhibitingOrganisation/ExhibitorMapper';

const defaultMultilingual = {
  description: ''
};

const findDataForLocale = (multilingualText, interfaceLocale) => {
  const availableLocales = multilingualText.map(attr => attr.locale.toLowerCase());
  if (availableLocales.includes(interfaceLocale.toLowerCase())) {
    return multilingualText.find(attr => attr.locale.toLowerCase() === interfaceLocale.toLowerCase());
  }
  return defaultMultilingual;
};

const fromProducerResponse = (producerResponse, interfaceLocale, primaryLocale) => {
  const lingual = findDataForLocale(producerResponse.multilingual, interfaceLocale);
  return {
    id: producerResponse.id,
    firstName: producerResponse.firstName,
    lastName: producerResponse.lastName,
    description: lingual.description,
    profileImage: producerResponse.profileImage,
    products: producerResponse.products ? (
      ProductMapper.fromResponse({ products: producerResponse.products }, interfaceLocale, primaryLocale)).products : [],
    representingCompanies: producerResponse.representingCompanies
      .map(representingCompany => ExhibitorMapper.fromBasicDetails(representingCompany, interfaceLocale, primaryLocale)),
    exhibitingCompanies: producerResponse.exhibitingCompanies
      .map(exhibitingCompany => ExhibitorMapper.fromBasicDetails(exhibitingCompany, interfaceLocale, primaryLocale))
  };
};

export default { fromProducerResponse };
